'use client';

import { formatPace } from '@streetferret/utils';
import { usePreferences } from '@streetferret/providers';
interface PaceProps {
  paceInSeconds: number;
}

export function Pace({ paceInSeconds }: PaceProps) {
  const { unit } = usePreferences();
  const unitNiceName = unit === 'imperial' ? 'mi' : 'km';

  const pace = formatPace(paceInSeconds);

  return (
    <div className="tabular-nums">
      <span>{pace}</span>
      <span>/</span>
      <span>{unitNiceName}</span>
    </div>
  );
}
